
  import {Component, Vue} from "vue-property-decorator";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class BalanceButton extends Vue {

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get balance() { return this.userAccess.balance; }
    get printLabel() { return this.balance >= 0 ? `На счете ` : `Долг `; }

    async openPopup() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'payment', dialogName: 'balancePopup' });
    }
  }
